import { EventBus } from '@primeuix/utils/eventbus';

export default EventBus();
